<div class="address-form">
    <div class="form-line">
        <mat-form-field class="garantor-form-field tipo-calle" appearance="outline">
            <mat-select [formControl]="formGroup.controls.tipoCalle">
                <mat-option *ngFor="let type of streetTypes" [value]="type.codigo">
                    {{ type.descripcion }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup.controls.tipoCalle.hasError('required')">
                Por favor seleccione una opción
            </mat-error>
        </mat-form-field>
        <mat-form-field class="garantor-form-field calle" appearance="outline">
            <mat-label>Calle</mat-label>
            <input matInput [formControl]="formGroup.controls.calle">
            <mat-error *ngIf="formGroup.controls.calle.hasError('required')">
                Por favor ingrese la calle
            </mat-error>
        </mat-form-field>
        <mat-form-field class="garantor-form-field numero" appearance="outline">
            <mat-label>Número</mat-label>
            <input matInput [formControl]="formGroup.controls.numero" type="number">
            <mat-error *ngIf="formGroup.controls.numero.hasError('required')">
                Por favor ingrese el número
            </mat-error>
        </mat-form-field>
    </div>
    <div class="form-line">
        <mat-form-field class="garantor-form-field piso" appearance="outline">
            <mat-label>Piso</mat-label>
            <input matInput [formControl]="formGroup.controls.piso">
        </mat-form-field>
        <mat-form-field class="garantor-form-field departamento" appearance="outline">
            <mat-label>Departamento</mat-label>
            <input matInput [formControl]="formGroup.controls.departamento">
        </mat-form-field>
        <mat-form-field class="garantor-form-field codigo-postal" appearance="outline">
            <mat-label>Cod. postal</mat-label>
            <input matInput [formControl]="formGroup.controls.codigoPostal" type="number">
            <mat-error *ngIf="formGroup.controls.codigoPostal.hasError('required')">
                Por favor ingrese el código postal
            </mat-error>
        </mat-form-field>
    </div>
    <app-locality-selector [formControl]="formGroup.controls.localidad" [provinces]="provinces"></app-locality-selector>
</div>
